import { FacilitiesTabInfo, FacilityTop, RoomInfo } from './../hotel-single.component';
import { Component, OnInit, Input, Inject } from '@angular/core';
import { trigger, transition, style, animate } from '@angular/animations';
import { DOCUMENT } from '@angular/common';

@Component({
  selector: 'app-hotel-single-facilities',
  templateUrl: 'hotel-facilities.component.html',
  styleUrls: ['hotel-facilities.component.css', 'hotel-facilities.component.scss'],
  animations: [
    trigger(
      'inOutAnimation',
      [
        transition(
          ':enter',
          [
            style({ height: 0, opacity: 0 }),
            animate('0.5s ease-out',
              style({ height: 300, opacity: 1 }))
          ]
        ),
        transition(
          ':leave',
          [
            style({ height: 300, opacity: 1 }),
            animate('0.5s ease-in',
              style({ height: 0, opacity: 0 }))
          ]
        )
      ]
    )
  ]
})

export class HotelSingleFacilitiesComponent implements OnInit {

  @Input() facilities: FacilitiesTabInfo;
  @Input() totalFacilities: Number;
  @Input() top5Facilities: Array<FacilityTop>;
  @Input() isVilla: Boolean;
  @Input() facilitiesSingle: Array<FacilityTop>;

  isOpen: Boolean = false;

  constructor(@Inject(DOCUMENT) private document: Document) { }

  ngOnInit() {
  }

  triggerMenu(openClose: boolean) {
    const modal = <HTMLDivElement>document.getElementById('md-modalFacilities');
    if (openClose) {
      this.document.body.setAttribute('style', 'overflow-y: hidden !important');
      modal.classList.add('md-show');
    } else {
      this.document.body.removeAttribute('style');
      modal.classList.remove('md-show');
    }
  }

  openTab() {
    const openArrow = <HTMLElement>document.getElementById('openArrow');
    const closeArrow = <HTMLElement>document.getElementById('closeArrow');
    if (!this.isOpen) {
      this.isOpen = true;
      openArrow.classList.add('hidden');
      closeArrow.classList.remove('hidden');
    } else {
      this.isOpen = false;
      openArrow.classList.remove('hidden');
      closeArrow.classList.add('hidden');
    }
  }

  isMobile() {
    const w = window.innerWidth;
    if (w < 992) {
      return true;
    }
    return false;
  }
}
